var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"course-create-details-tab"}},[_c('div',{staticClass:"vx-col w-full"},[_c('json-viewer',{staticClass:"rounded-lg",attrs:{"theme":"dark-json-theme","value":_vm.dataLocal}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }